// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.Modal_boxModal__HgjDE {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: 80%;
  max-height: 80%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
}

.Modal_boxModal__HgjDE .Modal_exit__p8Jm4 {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
}

.Modal_boxModal__HgjDE .Modal_exit__p8Jm4 .Modal_exitIcon__R2YWm {
  transition: 0.3s;
}

.Modal_boxModal__HgjDE .Modal_exit__p8Jm4 .Modal_exitIcon__R2YWm:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.Modal_boxModal__HgjDE .Modal_titleModal__H5WxV {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.Modal_boxModal__HgjDE .Modal_titleModal__H5WxV p {
  font-size: 1.5rem;
  margin: 0;
}

.Modal_boxModal__HgjDE .Modal_titleModal__H5WxV span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.Modal_boxModal__HgjDE .Modal_formFilters__aejhe {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 85%;
  margin-top: 8%;
}

.Modal_boxModal__HgjDE .Modal_formFilters__aejhe .Modal_filter__Fsmw2,
.Modal_filterByType__MDs6s {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 13%;
  margin-top: 1px;
}

.Modal_boxModal__HgjDE .Modal_formFilters__aejhe .Modal_filterByType__MDs6s p {
  color: #5a5a5a;
  font-size: 14px;
  margin-right: 25px;
}

.Modal_boxModal__HgjDE .Modal_formFilters__aejhe .Modal_filter__Fsmw2 .Modal_filterButton__UH0uq {
  width: 50%;
  height: 80%;
}

/* --------------- TABLE ---------------- */

.Modal_boxModal__HgjDE .Modal_dataContainer__ggpDW {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 400px;
}

.Modal_boxModal__HgjDE .Modal_dataContainer__ggpDW .Modal_tableContainer__wpA\\+8 {
  max-height: 400px;
  overflow-y: scroll;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Modal_message__u9zGj {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 28px;
  font-weight: 300;
}

@media screen and (max-width: 900px) {
  .Modal_boxModal__HgjDE {
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Create/Steppers/Modales/Modal/Modal.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 30%;\n  height: 80%;\n  max-height: 80%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .formFilters {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 85%;\n  margin-top: 8%;\n}\n\n.boxModal .formFilters .filter,\n.filterByType {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 13%;\n  margin-top: 1px;\n}\n\n.boxModal .formFilters .filterByType p {\n  color: #5a5a5a;\n  font-size: 14px;\n  margin-right: 25px;\n}\n\n.boxModal .formFilters .filter .filterButton {\n  width: 50%;\n  height: 80%;\n}\n\n/* --------------- TABLE ---------------- */\n\n.boxModal .dataContainer {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 400px;\n}\n\n.boxModal .dataContainer .tableContainer {\n  max-height: 400px;\n  overflow-y: scroll;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 28px;\n  font-weight: 300;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    height: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `Modal_boxModal__HgjDE`,
	"exit": `Modal_exit__p8Jm4`,
	"exitIcon": `Modal_exitIcon__R2YWm`,
	"titleModal": `Modal_titleModal__H5WxV`,
	"formFilters": `Modal_formFilters__aejhe`,
	"filter": `Modal_filter__Fsmw2`,
	"filterByType": `Modal_filterByType__MDs6s`,
	"filterButton": `Modal_filterButton__UH0uq`,
	"dataContainer": `Modal_dataContainer__ggpDW`,
	"tableContainer": `Modal_tableContainer__wpA+8`,
	"message": `Modal_message__u9zGj`
};
export default ___CSS_LOADER_EXPORT___;
